// src/services/speakingClubService.js
import api from "../api/axios";

export const speakingClubsAPI = {
  list: async (params = {}) => {
    const res = await api.get("/booking/speaking-clubs/", { params });
    return res.data;
  },
  getById: async (clubId) => {
    const res = await api.get(`/booking/speaking-clubs/${clubId}/`);
    return res.data;
  },
  create: async (data) => {
    const res = await api.post("/booking/speaking-clubs/create/", data);
    return res.data;
  },
  update: async (clubId, data) => {
    const res = await api.put(`/booking/speaking-clubs/${clubId}/update/`, data);
    return res.data;
  },
  remove: async (clubId) => {
    const res = await api.delete(`/booking/speaking-clubs/${clubId}/delete/`);
    return res.data;
  },
  bookings: async (clubId) => {
    const res = await api.get(`/booking/speaking-clubs/${clubId}/bookings/`);
    return res.data;
  },
};

// يحوّل أخطاء الـ DRF لنص واحد مقروء
export const flattenApiError = (data) => {
  if (!data) return "حدث خطأ، حاول مرة أخرى";
  if (typeof data === "string") return data;
  if (data.error) return flattenApiError(data.error);
  if (data.detail) return flattenApiError(data.detail);
  return Object.entries(data)
    .map(([k, v]) => {
      const msg = Array.isArray(v)
        ? v.map((x) => (typeof x === "object" ? JSON.stringify(x) : x)).join(" ")
        : typeof v === "object"
        ? JSON.stringify(v)
        : v;
      return `${k}: ${msg}`;
    })
    .join(" | ");
};
